import { OptionDescriptionModalTranslation, RequestQuoteContentTranslation, SiteTranslation } from './SiteTranslation';

// tslint:disable:max-line-length
const requestQuoteDefaultTranslation: RequestQuoteContentTranslation = {
  confirmation: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Bekreftelse',
    buttonLink: 'Fortsett å handle',
    title: 'Takk! Henvendelsen din er sendt.',
    content: 'Du vil snart bli kontaktet angående din forespørsel.',
  },
  goBackLink: 'Tilbake',
  title: 'Be om pristilbud',
  stepsTitle: 'Hva skjer med min forespørsel',
  steps: [
    'Din forespørsel vil bli mottatt av Flokk',
    'En salgsperson i Flokk, eller lokal forhandler vil forberede et pristilbud til deg',
    'Du vil bli kontaktet av Flokk salg eller lokal forhandler. ',
  ],
};

const requestQuoteProcessedByDealerTranslation: RequestQuoteContentTranslation = {
  ...requestQuoteDefaultTranslation,
  confirmation: {
    ...requestQuoteDefaultTranslation.confirmation,
    content: 'Du vil snart bli kontaktet angående din forespørsel.',
  },
  steps: [
    'Din forespørsel vil bli mottatt av Flokk',
    'En salgsperson i Flokk, eller lokal forhandler vil forberede et pristilbud til deg',
    'Du vil bli kontaktet av Flokk salg eller lokal forhandler. ',
  ],
};

const optionDescriptionModal: OptionDescriptionModalTranslation = {
  closeButton:
    'Lukk',
};

const translation: SiteTranslation = {
  layout: {
    topBar: {
      title: 'Flokk',
      chooseChairLink: 'Velg produkt',
      aboutUsLink: 'Om oss',
      inputSearchPlaceholder: '*Search',
      languages: {
        chDe: 'Tysk',
        chFr: 'Fransk',
        deDe: 'Tysk',
        dkDk: 'Dansk',
        enUs: 'Engelsk (US)',
        frFr: 'Fransk',
        nlNl: 'Nederlandsk',
        nbNo: 'Norsk',
        enGB: 'Engelsk',
        svSe: 'Svensk',
        plPl: 'Polsk',
      },
    },
    footerPanel: {
      emailLabel: 'e-post: ',
      phoneLabel: 'telefon: ',
      countactUsLink: 'Kontakt ditt lokale kontor',
      followUsLabel: 'Følg oss',
      copyright: 'Copyright',
      allRightReserved: 'All rights reserved',
    },
    titleFormat: '{title} - Flokk - Konfigurer din stol',
  },
  requestQuotePage: {
    errorMessage: 'Feil oppstod, kunne ikke laste skjema. Kontakt Support',
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Be om pris',
    defaultContent: requestQuoteDefaultTranslation,
    contentWhenProcessedByDealer: requestQuoteProcessedByDealerTranslation,
  },
  emailMyConfigurationPage: {
    errorMessage: 'Feil oppstod, kunne ikke laste skjema. Kontakt Support.',
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Be om pris',
    confirmation: {
      pageDescriptionFormat: 'Beskrivelse',
      pageTitleFormat: 'Bekreftelse',
      buttonLink: 'Gå tilbake til startsiden',
      title: 'Din konfigurasjon er sendt til mailadressen du oppga',
      content: 'Du vil snart bli kontaktet angående din forespørsel.',
    },
    goBackLink: 'Tilbake til sammendrag',
    title: 'Send min konfigurasjon på E-mail',
  },
  homePage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Hjem',
    articleList: {
      readMore: 'Les mer',
    },
    productList: {
      fromPriceLabel: '*From {price} inc VAT',
      productThumbnail: {
        productVariationList: {
          title: '*Variations'
        }
      }
    },
  },
  configurationSearchPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: '*Search for configuration',
    title: 'Tast inn konfigurasjons kode',
    description: 'og vi vil ta deg til stolen din',
    codeInputPlaceholder: 'Tast kode og trykk ‘enter’',
    configurationFinder: {
      codeWithIncorrectLengthFormat: 'Du må taste inn {expectedLength} tegn',
      codeInvalid: 'Vi finner ikke koden. Har du tastet den riktig?',
      codeNotFound: 'Beklager, vi fant ikke stolen din.',
    },
  },
  configurationDetailsPage: {
    pageTitleFormat: '*{code} - Configuration details',
    pageDescriptionFormat: '*{productName} {options} {accessories}',
    title: '*Your selected configuration',
    visualizationNotAvailableText: '*Visualization not available',
    configurationInvalidOrObsolete: 'Configuration is invalid or obsolete, please configure again before purchase.',
    unableToValidateConfigurationCode: 'There was a problem with validating configuration and purchase is disabled, please try again later or contact customer support.'
  },
  confirmationPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Bekreftelse',
    title: 'Gratulerer',
    errorTitle: 'En feil har oppstått',
    paymentConfirmed: '*Your payment is confirmed, we hope you enjoyed shopping with us.',
    checkYourEmail: '*For order & delivery details check your e-mail address.',
    errorContent: 'En feil har oppstått, vennligst kontakt support',
    orderSection: {
      title: '*Your order',
      orderNumber: '*Order number',
    },
    summarySection: {
      title: '*Summary',
      taxText: '*+ VAT',
      totalToPayText: 'total',
      contact: {
        contactAndBilling: '*Contact & Billing',
        deliveryAddress: '*Delivery address',
      },
    },
    designerSectionTitle: '*Do you know who designed your chair?',
    customerStorySectionTitle: '*Do you know how to sit?',
    readMore: '*Read more',
    contactUsSection: {
      text: '*If you have any question contact with our',
      linkText: '*customer service',
    },
  },
  checkoutPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Checkout',
    title: 'Checkout',
    goBackLink: 'Tilbake',
    progress: {
      title: 'Utsjekking',
      deliveryStep: 'Kontakt og levering',
      paymentStep: 'Betaling',
      confirmationStep: 'Bekreftelse',
    },
    goToPaymentButton: '*Confirm & pay with',
    paymentMethodLabel: '*How would you like to pay?',
    orderAndPayButton: '*Order and pay',
    submitButton: 'Send inn',
    paymentPoweredByText: '*We use a payment solution from',
    addressForm: {
      city: {
        name: 'By',
        placeholder: '',
        fieldRequired: 'Påkrevd felt: By',
      },
      country: {
        name: 'Land',
        placeholder: 'Land',
        fieldRequired: 'Påkrevd felt: Land',
      },
      street: {
        name: 'Gate',
        placeholder: 'Gate',
        fieldRequired: 'Påkrevd felt: Gate',
      },
      streetNumber: {
        name: 'Gatenummer',
        placeholder: 'Gatenummer',
        fieldRequired: 'Påkrevd felt: Gatenummer',
      },
      zipCode: {
        name: 'Postkode',
        fieldRequired: 'Påkrevd felt: Postkode',
        wrongFormat: 'Ugyldig Postkode',
      },
      availableCountries: {
        POL: 'Polen',
        NOR: 'Norge',
        CHE: 'Sveits',
        DEU: 'Tyskland',
        DNK: 'Danmark',
        FRA: 'Frankrike,',
        NLD: 'Nederland',
        SWE: 'Sverige',
        GBR: 'Storbritannia',
        USA: 'United States',
      },
      addressLine1: {
        name: 'Address Line 1',
        placeholder: '',
        fieldRequired: 'Adresselinje 1',
        wrongFormat: '',
      },
      addressLine2: {
        name: 'Adresselinje 2',
        placeholder: '',
        fieldRequired: '',
        wrongFormat: '',
      },
      recipient: {
        name: 'Mottaker',
        placeholder: '',
        fieldRequired: 'Mottaket er påkrevd',
        wrongFormat: '',
      },
    },
    contactForm: {
      contactDetails: 'Kontakt og fakturering ',
      email: {
        name: 'E-mail adresse',
        placeholder: '',
        fieldRequired: 'Påkrevd felt: E-post',
        wrongFormat: 'Ugyldig E-post',
      },
      phone: {
        name: 'Telefonnummer',
        placeholder: '',
        fieldRequired: 'Påkrevd felt: Telefon',
        wrongFormat: '*Entered value is not a valid phone number',
      },
      phonePrefix: {
        name: '*Prefix',
        placeholder: '+ _ _',
        fieldRequired: '*Prefix is required',
        wrongFormat: '*Entered value is not a valid phone prefix',
      },
      firstName: {
        name: 'Fornavn',
        placeholder: '',
        fieldRequired: 'Påkrevd felt: Fornavn',
      },
      lastName: {
        name: 'Etternavn',
        placeholder: '',
        fieldRequired: 'Påkrevd felt: Etternavn',
      },
      companyName: {
        name: 'Selskapsnavn (valgfritt)',
        placeholder: '',
      },
      taxId: {
        name: 'Bedriftsskatt ID',
        placeholder: '',
        fieldRequired: 'Bedriftsskatt ID er påkrevd',
      },
    },
    shippingMethodSection: {
      subtitle: 'Delivery method',
      shippingMethod: {
        name: 'Shipping Method',
        fieldRequired: 'This field is required',
      },
    },
    deliveryAddressSection: {
      subtitle: 'Leveringsadresse',
      billingAndDeliveryAreTheSameText: 'Fakturering og leveringsadresse er de samme',
      deliveryInfoText: 'Gratis hjemme levering på 10-15 dager',
    },
    paymentMethods: {
      supportedCreditCardsMessage: {
        acceptedCreditCardsText: '*We accept the following payment cards',
      },
      klarna: {
        selectPaymentCategory: `*Please select payment category:`
      }
    },
    readyToOrderSection: {
      subtitle: 'Klar til å bestille?',
      termsAndConditions: {
        termsAndConditionLinkName: 'Terms & Conditions',
        name: 'Jeg accepterer vilkårene ',
        placeholder: '',
        fieldRequired: 'Dette feltet er påkrevd',
      },
      subscription: "*I'd like to receive additional…",
    },
    readyToOrderPaymentSection: {
      subtitle: '*Ready to order?',
    },
    errors: {
      creatingOrderFailed: '*Unable to place order. Please try again or contact customer support.',
      initializingPaymentFailed: '*Payment processing failed. Please try again or contact customer support.',
      authorizingPaymentFailed: '*Authorization failed. Please try again or contact customer support.',
      finalizingPaymentFailed: '*Payment processing failed. Please try again or contact customer support.',
    },
    discountCodeForm: {
      applyButton: '*Apply',
      discountCodeIsAppliedMessage: '*The "{code}" discount code is applied.',
      discountCodeIsInvalidOrExpiredError: '*The code you entered is invalid or has expired.',
      doYouHaveDiscountCodeText: '*Do you have a promotion or campaign code?',
      enterCodeText: '*Insert code here',
      label: '*Promo code',
    },
  },
  checkoutShortcutPage: {
    pageTitleFormat:
      'Checkout shortcut',
    pageDescriptionFormat:
      '',
    errors: {
      addingProductToCartFailed:
        'Unable to purchase product configuration with code {code}. Please contact customer support.',
      gettingProductConfigurationFailed:
        'Unable to retrieve information about product configuration with the code {code}. Please refresh page or contact customer support.',
    }
  },
  configurationPage: {
    pageDescriptionFormat: '{productName} {options} {accessories}',
    pageTitleFormat: '{productName} - Konfigurator',
    productDetails: {
      documentsSection: 'Dokumenter',
      moreInformationSection: 'Mer informasjon',
      specificationSection: 'Spesifikasjon',
    },
    showFiltersText: '*Show filters',
    hideFiltersText: '*Hide filters',
    productModels: {
      chooseModelText: '*Choose your model',
      modelSelectorWithLoader: {
        noOtherModelsAvailable: '*There are no other models available.',
      },
    },
    options: {
      title: 'Bygg din stol',
      priceGroup: 'Prisgruppe',
      textSelected: 'Valgt',
      fabricFilters: {
        noFabricsAvailable: 'Det finnes ingen stoffer som passer til dine preferanser.',
        clearButton: 'Tøm',
        defaultFilterName: 'Alle',
        collectionFilterLabel: '*Collection'
      },
    },
    accessories: {
      title: 'Tilbehør',
      accessory: {
        removeButton: 'Ta bort',
        addButton: 'Legg til',
        textSelected: 'Valgt',
      },
    },
    summary: {
      title: 'Din stol',
      accessoriesSubtitle: 'Tilbehør',
      requestQuoteButton: 'Be om pris',
      emailConfirmationButton: 'Send min konfigurasjon på e-post',
      limitedChairQuantity: '*To order more than {max} chairs please contact us',
      checkoutButton: 'Utsjekking',
      editConfigurationLink: 'Endre',
      expectedShipment: {
        expectedShipment: '*Ready for shipping within',
        days: '*working days',
      },
      quantityInput: {
        outOfRangeWarning: 'Verdien må være mellom {min} og {max}',
      },
      saveYourConfigurationHereButton: '*Save your configuration here.',
      backButton: '*Back',
      shareSection: {
        title: 'Lagre din konfigurasjon',
        yourConfigurationUrl: 'Din konfigurasjonslenke',
        codeShare: {
          codeTitle: 'Din konfigurasjonskode',
          copyCode: {
            label: 'Kopier koden',
            textCopiedLabel: 'Kopiert',
          },
        },
        downloadAsPdf: 'Last ned som PDF',
        downloadVisualizations: 'Last ned visualiseringer',
        copyLink: {
          label: 'Kopier linken',
          textCopiedLabel: 'Kopiert',
        },
        closeButton: 'Lukk',
      },
      findLocalDealerSection: {
        title: 'Hvor er Flokk',
        button: 'Finn din lokale forhandler',
      },
    },
    restrictions: {
      accessorySelection: {
        header: {
          userSelectionNotRequiredFormat: 'Er du sikker på at du vil legge til {itemName}?',
          userSelectionRequiredFormat: 'Hvis du vil legge til {itemName}, må du endre innstillinger',
        },
        automaticDeselectionOfAccessoriesFormat:
          'Valgte tilbehør er ikke tilgjengelig med {itemsToDeselect}. Hvis du velger dette tilleggsutstyret, vil tilbehørene nedenfor bli fjernet fra bestillingen din.',
      },
      optionSelection: {
        header: {
          userSelectionNotRequiredFormat: `Er du sikker på at du vil endre {itemName} -alternativet?`,
          userSelectionRequiredFormat: `Hvis du vil endre {itemName}, må du endre preferanser`,
        },
        automaticDeselectionOfAccessoriesFormat:
          'Valgt alternativ er ikke tilgjengelig med {itemsToDeselect}. Hvis du velger dette alternativet, vil tilbehørene nedenfor bli fjernet fra bestillingen din.',
      },
      itemNotAvailableWithFormat: '{itemToSelect} er ikke tilgjengelig med {itemsToDeselect}.',
      itemsSeparator: ' og ',
      selectMatchingOption: ' Nedenfor finner du de valg som passer',
      cancelButton: 'Avbryt',
      applyButton: 'Ok, endre',
      closeButton: 'Lukk',
      selectedText: 'Valgt',
    },
    tabs: {
      fabrics: {
        name: 'Stoffer',
      },
      options: {
        name: 'Alternativer',
      },
      accessories: {
        name: 'Tilbehør',
      },
      summary: {
        name: 'Sammendrag',
      },
    },
    productNotAvailableInCurrentStoreWarning: {
      messageFormat:
        '*This product is not available in your country ({currentStore}). If you like it please contact customer support.',
    },
    productInactiveWarning: {
      discontinued: '*This is a discontinued product',
      generic: '*Product is not available',
      genericWithReason: '*Product is not available: {reason}'
    },
    obsoleteCodeModal: {
      notAvailable: {
        title: '*Chair configuration is not available',
        intro: 'Given product configuration is not available.',
        introWithCodePart1: 'Given product configuration with the code',
        introWithCodePart2: 'is not available.',
        explanation: "The following parts or materials can't be used anymore:",
      },
      restricted: {
        title: '*Chair configuration is not valid',
        intro: 'Given product configuration is not valid.',
        introWithCodePart1: 'Given product configuration with the code',
        introWithCodePart2: 'is not valid.',
        explanation: 'This might be caused by changes in the product set up.',
      },
      footer: 'Please configure your chair once again.',
      closeButton: 'Close',
    },
    optionDescriptionModal,
    metaTitleFormat: 'Min {productName}',
    metaDescriptionFormat: '{productName}: {options}',
    priceTaxText: 'Inkludert skatter',
  },
  modularConfiguratorPage: {
    pageDescriptionFormat: '{productName} {options} {accessories}',
    pageTitleFormat: '{productName} - Konfigurator',
  },
  storeAndLanguageSelector: {
    title: 'Velg land og språk',
    storeSelectorLabel: 'Land',
    languageSelectorLabel: 'Språk',
  },
  initialStoreSelectorModal: {
    title: 'Hi there',
    description: 'Find your country or go to our international page',
    buttonContinue: 'Continue',
    inputPlaceholder: 'Select your country',
    languageInputPlaceholder: '*Select language',
    linkLabelInternationalStore: 'Go to international page',
    noOptionMessage: 'This country is not found',
    noLanguageMessage: '*This language is not found',
  },
  noConnectionModal: {
    title: 'Whooops!',
    content: 'Ingen internettforbindelse',
    continueLink: 'Fortsett',
    buttonSeparator: 'eller',
    refreshButton: 'Oppdater side',
    closeButton: 'Lukk',
  },
  emptyCartPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Tom handlevogn',
    basketEmptyLine1: 'Din handlekurv er tom',
    basketEmptyLine2: 'men det trenger ikke være',
    continueButton: 'Fortsett å handle',
  },
  pageNotFound: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Side ikke funnet',
    content: 'Siden du forsøker nå eksisterer ikke',
    title: 'Uuups!',
    buttonLink: 'Tilbake',
  },
  generalErrorPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Feil',
    title: 'Siden kan ikke vises',
    content: 'Vennligst prøv igjen senere',
    buttonLink: 'Prøv igjen',
  },
  invalidCodePage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Ugyldig kode',
    title: 'Ugyldig konfigurasjons kode',
    content: 'Vennligst skriv inn en gyldig konfigurasjonskode',
    buttonLink: 'Tilbake til FLOKK',
  },
  productSpecificationPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Produktspesifikasjon',
    accessoriesSection: 'Tilbehør',
    linkTitle: 'Din konfigurasjonslenke',
    codeTitle: 'Din konfigurasjonskode',
    pricesSection: {
      unitPrice: 'Pris per enhet',
      quantity: 'Kvantitet',
      subtotalPrice: 'Total',
    },
    dataSection: {
      title: 'Data',
      brand: 'Merke',
      code: 'Artikkelnummer',
    },
  },
  storeLocatorPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Forhandlere, showroom og Flokk kontor',
    heading: 'Finn din forhandler, showroom eller Flokk kontor',
    storeSearch: {
      noDealersText: 'Beklager, vi har ingen forhandlere i dette området',
      noDealersWithFiltersText: 'Beklager, vi har ingen forhandlere eller kontor i dette området ',
      filterResultText: '{storesNumber} forhandlere funnet',
      storeLocatorInput: {
        label: 'Finn butikken din',
        placeholder: 'Søk på adresse eller by',
        orText: 'og',
        currentLocationText: 'bruk min lokasjon',
        disabledGeolocationText: 'Lokasjonstjeneste er deaktivert.',
        unavailableGeolocationText: 'Lokasjonstjeneste er utilgjengelig.',
        tryAgainText: 'Forsøk igjen',
      },
      storeLocatorFilters: {
        title: 'Filtere',
        placesLabel: 'Type sted',
        brandLabel: 'Merkevare',
      },
    },
    storeTypes: {
      Showroom: 'Showroom',
      Shop: 'Butikk',
    },
    details: {
      webSite: 'Nettsted',
      address: 'Adresse',
      directionLink: 'Veibeskrivelse',
      email: 'E-post',
      openHours: 'Åpningstider',
      phone: 'Telefon',
      closeButton: 'Lukk',
      backButton: 'Tilbake til listen',
    },
  },
  cart: {
    summary: {
      deliveryFee: 'Fraktkostnader',
      subTotal: 'Price before VAT',
      totalTaxFormat: 'Vat ({taxTotal}%)',
      subTotalWithTax: 'Total price including VAT',
      totalToPay: 'Totalt å betale',
      moreInformationText: 'Mer informasjon',
      lessInformationText: 'Mindre informasjon',
      quantityText: 'Antall',
      shippingTimeText: {
        deliveredWithin: '*Delivered within',
        day: '*day',
        days: '*days',
        week: '*week',
        weeks: '*weeks',
      },
      configurationCodeLabel: 'Kode',
      deliveryCostUnavailable: 'Select shipping method',
      freeDeliveryText: 'Gratis frakt',
      taxText: 'Moms',
      discount: '*Discount',
      surcharges: {
        'eco-tax': '*Eco tax'
      },
    },
  },
  redirectionWarningModal: {
    closeButton: 'Lukk',
    title: "You'll be automatically redirected in a few seconds. Interact with the screen to cancel redirection.",
  },
  scrollToTop: {
    button: '*Go to top',
  },
  productFamilyPage: {
    pageDescriptionFormat: 'Beskrivelse',
    pageTitleFormat: 'Produktside',
    overviewSection: {
      name: 'Oversikt',
    },
    designerSection: {
      name: 'Designer',
      designedBy: 'Designet av',
      readMore: 'Les mer',
    },
    relatedProducts: {
      name: 'Relaterte produkter',
      title: 'Du vil kanskje også like',
    },
    productUserStories: {
      name: '*Projects',
      readMore: 'Les mer',
      title: '*Project',
    },
    modelsSection: {
      name: 'Modell',
      productInfo: {
        priceSection: {
          taxText: 'Inkludert skatter',
          fromText: 'fra',
        },
        popularDesigns: {
          title: 'Populære design kombinasjoner',
        },
        actions: {
          configureChairButton: 'Design din egen stol',
          askForPriceButton: 'Be om pris',
          goToCheckoutButton: '*Add to cart',
          whereToBuyButton: '*Where to buy',
        },
        whereToBuy: {
          text: '*We sell our products through a network of authorized partners.',
          designCustomChairText:
            '*However, if you’d like to create a bespoke chair please design your own above and we’ll come back to you with a price.',
        },
      },
      productModelSelector: {
        heading: '*Choose your variant',
      },
      modelViewer: {
        hint: 'Klikk på bildet for å åpne zoom-modus',
      },
    },
    productModelDetailsSection: {
      assetsDownloader: {
        downloadAllButton: '*Download all',
        other: '*Other',
        categories: {},
      },
      downloadsSectionTitle: '*Downloads',
      environmentalDataSection: {
        averagedValuesDisclaimerText:
          '*All values are average for this model, for some products the numbers might differ.',
        energyUsageMjText: '*Energy usage',
        co2EmissionKgText: '*Carbon dioxide emission',
        recyclableMaterialsText: '*recyclable materials',
        recycledAluminiumText: '*recycled aluminium',
        recycledMaterialsTitle: '*Ratio of recycled materials',
        recycledMaterialsText: '*recycled materials',
        recycledPlasticText: '*recycled plastic',
        recyclableMaterialsTitle: '*Recycling rate',
      },
      environmentalDataSectionTitle: '*Environmental data',
      name: '*Details',
      specificationSectionTitle: '*Specification',
    },
    suggestedConfigurationsSection: {
      name: 'Variasjoner',
      title: 'Ser du etter noe spesielt?',
      subtitle: 'Velg mellom alternativer som farge, tekstiler, materialer, tilbehør og mer.',
      buttonText: 'Design din egen Capisco',
    },
    gallerySection: {
      name: 'Galleri',
    },
    userGuideVideoSection: {
      name: '',
      videoTitle: 'User demo',
    },
  },
  viewerPage: {
    pageDescriptionFormat: 'Page description',
    pageTitleFormat: 'Viewer page',
  },
  zoomModal: {
    closeButton: 'Lukk',
  },
  common: {
    chairVisualization: {
      zoomHintText: 'Trykk for å zoome inn/ut',
      hintText: 'Klikk på bildet for å åpne zoom-modus',
      renderingError: '*Sorry, we are not able to load visualisation for this configuration.',
      webGLUnsupportedError:
        '*Sorry, we are not able to load visualisation, because WebGL is not supported in your browser.',
    },
    tags: {
      clearResults: '*Remove all',
    },
  },
  catalogPage: {
    pageTitleFormat: '*Products',
    pageDescriptionFormat: '*Find your chair ',
    filterBar: {
      name: 'Filters',
      results: '*All results: {results}',
    },
    configurationFinder: {
      codeWithIncorrectLengthFormat: 'Du må taste inn {expectedLength} tegn',
      codeInvalid: 'Vi finner ikke koden. Har du tastet den riktig?',
      codeNotFound: 'Beklager, vi fant ikke stolen din.',
    },
    productFamily: {
      showMoreProducts: '*More options available',
    },
    searchForConfigurationText: '*Already made a design? Find your configuration',
    noResults: '*There are no products matchingy our preferences.',
    pagination: {
      title: '*Pagination',
    },
  },
  disclaimer: {
    messagePart1: '*The appearance of the color depends on your device or screen setup. ',
    link: '*Contact us',
    messagePart2: ' *if you need help choosing the right colour and/or texture.',
  },
  requestQuoteLink: {
    link: '*Buying for a company? Request a quote here.',
  },
  unauthorizedErrorPage: {
    pageDescriptionFormat: '*Description',
    pageTitleFormat: '*Unauthorized',
    title: '*Unauthorized',
    content: '*Access is allowed only for registered users.',
    buttonLink: '*Login',
  },
  forbiddenErrorPage: {
    pageDescriptionFormat:
      '*You do not have necessary permissions to access this page.',
    pageTitleFormat:
      '*Forbidden',
    title:
      '*Oh, no!',
    content1:
      '*You do not have the necessary permissions to access this page. You can ',
    logout:
      'log out',
    content2:
      ' and try another account or contact Flokk support.',
    buttonLink:
      '*Take me home'
  },
  downloadsPage: {
    downloadList: {
      download: {
        downloadButton: '*Download',
      },
      emptyScreen: {
        title: '*There are no files matching your criteria.',
        description: '*Sorry, we don’t seem to have what you are looking for. Please try different filters.',
      },
      results: '*There are {results} files matching you criteria.',
      pagination: {
        title: '*Pagination',
      },
    },
    filters: {
      title: '*Filters',
      brandsFilter: {
        name: '*Popular brands',
      },
      categoryFilter: {
        name: '*Category',
        fileTypeFilter: {
          name: '*File type',
        },
        resultsCounter: '*All results',
      },
      downloadAllButton: '*Download all',
    },
    pageTitleFormat: '*Downloads',
    pageDescriptionFormat: '*Find and download product resources, such as fact sheets, images, CADs etc.',
  },
  readyMadeProductPage: {
    overviewSection: {
      name: '*Overview',
    },
    variationsSection: {
      name: '*Variations',
    },
    specificationSection: {
      name: '*Specification',
    },
    productDetailsSection: {
      specificationSectionTitle: '*Specification',
      maintenanceSectionTitle: '*Maintenance',
      downloadsSectionTitle: '*Downloads',
      assetsDownloader: {
        downloadAllButton: '*Download all',
        other: '*Other',
        categories: {},
      },
      productCare: {
        downloadGuide: '*Download guide here',
      },
    },
    productVariations: {
      addToCartButton: '*Add to cart',
      buyButton: '*Buy',
      deliveryTime: {
        deliveryTime: '*Delivery time',
        day: '*day',
        days: '*days*',
        week: '*week',
        weeks: '*weeks*',
      },
      priceIncludingTax: '*Incl. Tax, plus shipping cost',
      deliveryTimeAnnotation: '** Delivery time may be longer for some configurations',
      modelViewer: {
        hint: 'Klikk på bildet for å åpne zoom-modus',
      },
      customizationSection: {
        textLine1: '*Looking for something different?',
        textLine2: '*You can',
        linkText: '*customise your choice here',
      },
      productOptions: {
        fabricInfo: {
          text: '*Fabric information:',
          optionDescriptionModal,
        },
        fabricDescriptionCannotBeLoadedError:
          '*Sorry, something went wrong. Cannot load the information about the fabric.',
      },
    },
    productCarousel: {
      title: '*Others have also looked at these chairs',
    },
  },
};

export default translation;
